export class StubMessenger {
    constructor() {
        this.messages = [];
    }
    async send(message) {
        // Touch all rendered fields so a throwing getter (e.g. accessing an unloaded
        // relation) surfaces in tests instead of only blowing up in production.
        void message.recipient;
        void message.title;
        void message.text;
        void message.html;
        void message.sender;
        void message.replyTo;
        void message.attachments;
        this.messages.unshift(message);
    }
    lastMessage(addr) {
        return this.messages.find(({ recipient }) => recipient === addr) || null;
    }
}
//# sourceMappingURL=messenger.js.map